import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {StatusCheckParams} from '@app/domain/model/status-check-params';

@Injectable({
  providedIn: 'root'
})
export class StatusCheckService {
  requestParams:HttpParams;

  constructor(private http: HttpClient) {
  }

  queryStatusChecking(params: StatusCheckParams): Observable<string> {

    this.requestParams = new HttpParams()
      .set('reportDate', params.reportDate)
      .set('licenseNumber', String(params.sellerId));

    return this.http
      .get(`license/status/`, { headers: { 'Content-Type': 'application/json' }, params: this.requestParams })
      .pipe(
        map(response => {
          return response as string;
        })
      );
  }
}
